<template>
  <q-layout view="lHh Lpr lFf">
    <q-header class="header">
      <div class="max-width-limited full-height">
        <div class="row items-center q-ml-md q-mr-md full-height">
          <q-btn
            round
            color="#fff"
            text-color="grey-9"
            class="menu-burger"
            icon="menu"
            @click="isOpenSidePanel = true"
          />

          <div class="col-4 _desktop">
            <img alt="logo" :src="isElectron() ? apiUrl + style.logo : style.logo" @click="home()">
          </div>
          <div class="col text-center semi-bold">{{pageTitle}}</div>
          <div class="col text-right text-color2 _desktop">{{$t('mainLayout.shopTitle')}}: <span v-if="shop">{{shop.name}}</span></div>
          <div class="header__account_lang text-grey-6 _desktop">
            <span
              class="cursor-pointer"
              :class="{active: activeLocale === 'ru-ru'}"
              @click="changeLang('ru-ru')"
            >
              {{ $t('mainTerms.rus') }}
            </span>
            /
            <span
              class="cursor-pointer"
              :class="{active: activeLocale === 'en-us'}"
              @click="changeLang('en-us')"
            >
              {{ $t('mainTerms.eng') }}
            </span>
            <q-btn
              v-if="apiUrl"
              round
              class="q-ml-md _desktop"
              color="#fff"
              text-color="grey-9"
              icon="logout"
              @click="clearApiUrl"
            />
          </div>
        </div>

      </div>

      <mobile-side-menu
        :open="isOpenSidePanel"
        :shop="shop"
        :style-obj="style"
        :activeLocale="activeLocale"
        :api-url="apiUrl"
        @close="isOpenSidePanel = false"
        @changeLocale="changeLang"
      />
    </q-header>

    <q-page-container>
      <transition name="page" mode="out-in">
        <router-view :api-url="apiUrl" />
      </transition>
    </q-page-container>

    <q-dialog v-model="errorModal.enabled" persistent transition-show="scale" transition-hide="scale">
      <q-card style="min-width: 200px">
        <q-card-section>
          <div class="text-h6">{{$t('mainLayout.errorModalTitle')}}</div>
        </q-card-section>

        <q-card-section>
          {{ errorModal.message }}
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="OK" @click="handleCloseErrorModal()" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <div class="hidden-camera" ref="bgVideo" />
  </q-layout>
</template>

<script>
import { mapState } from 'vuex'
import { isElectron } from '../common/helpers'
import CamService from '../pages/camService'
import { TickSyncWatcher } from '../modules/tick-sync'
import MobileSideMenu from '../components/MobileSideMenu'

export default {
  name: 'MyLayout',

  components: {
    MobileSideMenu
  },

  data () {
    return {
      pageTitle: '',
      ticksSyncWatcher: null,
      isOpenSidePanel: false,
      apiUrl: '',
      apiUrlTimer: null,
      isElectron
    }
  },

  computed: {
    ...mapState(['shop', 'errorModal', 'tickPoint', 'firstPicsPaused', 'style']),
    activeLocale () { return this.$store.state.locale }
  },

  mounted () {
    this.$router.afterEach((to) => {
      this.updateTitleFunc(to)
    })

    this.updateTitleFunc(this.$router.currentRoute)

    this.startCollectFirstPhotos()
    if (process.env.IS_SYNC_TICK_ENABLED) {
      this.ticksSyncWatcher = new TickSyncWatcher(this.$store.dispatch.bind(this, 'fetchTicks'))
      this.ticksSyncWatcher.start()
    }
    this.apiUrlTimer = setInterval(this.updateApiUrl, 1000)
  },

  beforeDestroy () {
    if (this.ticksSyncWatcher) {
      this.ticksSyncWatcher.stop()
    }
    if (this.apiUrlTimer) {
      clearInterval(this.apiUrlTimer)
    }
  },

  methods: {
    home () {
      this.$router.push('/')
    },

    handleCloseErrorModal () {
      this.$store.commit('setErrorModal', {
        enabled: false,
        message: ''
      })
    },

    startCollectFirstPhotos () {
      const camService = new CamService(this.$refs.bgVideo)
      camService.initialize()
      setInterval(async () => {
        if (!this.firstPicsPaused) {
          const pic = await camService.getPicture()
          this.$store.commit('addFirstPic', pic)
        }
      }, 1000)
    },

    changeLang (lang) {
      this.$store.dispatch('changeLocale', lang)
      this.$router.afterEach((to) => {
        this.updateTitleFunc(to)
      })
      this.updateTitleFunc(this.$router.currentRoute)
    },

    updateTitleFunc (to) {
      let path = to.path.substr(1)
      if (path === '') path = 'select'
      this.pageTitle = this.$t(`pages.${path}.title`)
    },

    updateApiUrl () {
      this.apiUrl = localStorage.getItem('apiUrl')
    },

    clearApiUrl () {
      localStorage.removeItem('apiUrl')
    }
  }
}
</script>

<style lang="stylus">
body
  overflow-x: hidden
.header
  height: 64px
  background-color: $bg-color
  color: $text-color
  font-size: 16px
  &::after
   display: block
   width: 100%
   height: 5px
   content: ''
   background-color: $bg-color2
  img
    max-width: 100%
    max-height: 50px
    vertical-align: middle
    cursor: pointer
  &__account_lang
    margin: 0 0 0 15px
  &__account_lang
    text-transform: uppercase
    font-size: 11px
    & .active
      color: var(--q-color-primary)

.menu-burger
  display: none
  color: #000

.q-dialog__inner--fullheight
  padding: 0 !important

@media (max-width: 900px)
  .menu-burger
    display: block

  ._desktop
    display: none

</style>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s/*, transform 0.5s; */
}
.page-enter, .page-leave-to {
  opacity: 0;
  /* transform: translateX(-50%); */
}
</style>
